import * as _ from './imports';

export default _;
export * from './imports';

export function useLodash() {
  return _}